import * as React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { absoluteUrl, cn, getInitials, getAvatarColor } from "@/utils/common.utils";

interface UserAvatarProps extends React.ComponentPropsWithoutRef<typeof Avatar> {
  name?: string;
  /** Profile photo. Initials show while it loads, or if it is missing or fails. */
  src?: string;
  fallbackClassName?: string;
  colored?: boolean;
}

export default function UserAvatar({ name, src, className, fallbackClassName, colored, ...props }: UserAvatarProps) {
  return (
    <Avatar className={className} {...props}>
      {src && <AvatarImage src={absoluteUrl(src)} alt={name || ""} className="object-cover" />}
      <AvatarFallback
        className={cn("text-[10px] font-semibold text-white", !colored && "bg-primary text-primary-foreground", fallbackClassName)}
        style={colored ? { backgroundColor: getAvatarColor(name) } : undefined}
      >
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
